var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"blog-pagination"},[_vm._l((_vm.max_num_pages),function(i){return [(_vm.paginationNumsToShow.includes(i))?_c('router-link',{key:i,class:{ selected: _vm.page == i },attrs:{"to":{
						name: _vm.pathName,
						params: {
							tagSlug: decodeURI(_vm.tagSlug),
							page: i,
							noScroll: true,
						},
					}},nativeOn:{"click":function($event){return _vm.test.apply(null, arguments)}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(i)+"\n\t\t\t\t")]):_c('a',{staticClass:"dots"},[_vm._v("...")])]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }